<template>
    <div class="deposit-identifier">
      <h2>🔖 تولید شناسه واریز</h2>
  
      <!-- دکمه باز کردن فرم -->
      <button class="btn-primary" @click="showForm = true">
        + تولید شناسه واریز
      </button>
  
      <!-- مودال فرم اطلاعات -->
      <div v-if="showForm" class="modal-overlay">
        <div class="modal-content">
          <h3>📝 فرم اطلاعات کاربر</h3>
  
          <input v-model.trim="formData.firstName" type="text" placeholder="نام (فقط فارسی)" />
          <input v-model.trim="formData.lastName" type="text" placeholder="نام خانوادگی (فقط فارسی)" />
          <input v-model.trim="formData.mobile" type="text" placeholder="شماره موبایل (11 رقم با 09)" />
          <input v-model.trim="formData.nationalCode" type="text" placeholder="کد ملی" />
          <select v-model="formData.bankAccount">
            <option v-for="account in bankAccounts" :key="account.id" :value="account">
                {{ account.bankName }} - {{ account.accountNumber }}
            </option>
          </select>
  
          <div v-if="formError" class="error">{{ formError }}</div>
  
          <div class="actions">
            <button class="btn-success" @click="generateCode">✅ تولید کد</button>
            <button class="btn-secondary" @click="closeForm">❌ بستن</button>
          </div>
  
          <div v-if="generatedCode" class="result">
            <p>🔐 کد تولید شده:</p>
            <strong>{{ generatedCode }}</strong>
          </div>
        </div>
      </div>
  
      <!-- بررسی اعتبار کد -->
      <h3>✅ بررسی اعتبار کد واریز</h3>
      <input v-model.trim="verifyCodeInput" type="text" placeholder="کد را وارد کنید" />
      <button class="btn-primary" @click="verifyCode">بررسی</button>
  
      <div v-if="verifyResult !== null">
        <p v-if="verifyResult == 1" class="success">✅ کد معتبر است اما پرداختی ثبت نشده است</p>
        <div v-else-if="verifyResult == 2">
            <p class="success">✅ کد معتبر است و 3 پرداخت موفق ثبت شده است </p>
            <hr>
            <p class="error">شما مجاز به مشاهده تراکنش انجام شده نمی باشید</p>
        </div>
        <p v-else class="error">❌ کد نامعتبر است</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "DepositIdentifier",
    data() {
      return {
        showForm: false,
        formError: "",
        generatedCode: "",
        verifyCodeInput: "",
        verifyResult: null,
        bankAccounts: [
            { id: 1, bankName: "ملت", accountNumber: "IR820540102680020817909101" },
            { id: 2, bankName: "ملی", accountNumber: "IR290170000000000235679002" },
            { id: 3, bankName: "صادرات", accountNumber: "IR620560078900000124578903" }
        ],
        formData: {
          firstName: "",
          lastName: "",
          mobile: "",
          nationalCode: "",
           bankAccount: { id: 1, bankName: "ملت", accountNumber: "IR820540102680020817909101" },
        }
      };
    },
    methods: {
      closeForm() {
        this.showForm = false;
        this.resetForm();
      },
      resetForm() {
        this.formError = "";
        this.generatedCode = "";
        this.formData = {
          firstName: "",
          lastName: "",
          mobile: "",
          nationalCode: ""
        };
      },
      generateCode() {
        if (!this.validateForm()) return;
  
        const randomNum = Math.floor(1000 + Math.random() * 9000);
        const rawCode = this.formData.nationalCode + randomNum;
        const checkDigit = this.verhoeffGenerate(rawCode);
  
        this.generatedCode = rawCode + checkDigit;
      },
      verifyCode() {
        const code = this.verifyCodeInput;
        // this.verifyResult = code.length >= 11 && this.verhoeffValidate(code);

        if(code.length >= 11 && this.verhoeffValidate(code)){
            this.verifyResult = 1;
            if(code == '181842204241071'){
                this.verifyResult = 2;
            }
        } else {
            this.verifyResult = 0;
        }

      },
      validateForm() {
        const { firstName, lastName, mobile, nationalCode } = this.formData;
  
        if (!/^[\u0600-\u06FF\s]{2,30}$/.test(firstName)) {
          this.formError = "❌ نام فقط باید با حروف فارسی و حداقل ۲ حرف باشد.";
          return false;
        }
        if (!/^[\u0600-\u06FF\s]{2,30}$/.test(lastName)) {
          this.formError = "❌ نام خانوادگی فقط باید با حروف فارسی و حداقل ۲ حرف باشد.";
          return false;
        }
        if (!/^09\d{9}$/.test(mobile)) {
          this.formError = "❌ شماره موبایل باید ۱۱ رقم و با 09 شروع شود.";
          return false;
        }
        if (!this.validateNationalCode(nationalCode)) {
          this.formError = "❌ کد ملی نامعتبر است.";
          return false;
        }
  
        this.formError = "";
        return true;
      },
      validateNationalCode(code) {
        if (!/^\d{10}$/.test(code)) return false;
        const check = +code[9];
        const sum = code
          .split('')
          .slice(0, 9)
          .reduce((acc, digit, i) => acc + +digit * (10 - i), 0);
        const remainder = sum % 11;
        return (remainder < 2 && check === remainder) || (remainder >= 2 && check === 11 - remainder);
      },
      verhoeffGenerate(number) {
        const d = [
            [0,1,2,3,4,5,6,7,8,9],
            [1,2,3,4,0,6,7,8,9,5],
            [2,3,4,0,1,7,8,9,5,6],
            [3,4,0,1,2,8,9,5,6,7],
            [4,0,1,2,3,9,5,6,7,8],
            [5,9,8,7,6,0,4,3,2,1],
            [6,5,9,8,7,1,0,4,3,2],
            [7,6,5,9,8,2,1,0,4,3],
            [8,7,6,5,9,3,2,1,0,4],
            [9,8,7,6,5,4,3,2,1,0]
        ];
        const p = [
            [0,1,2,3,4,5,6,7,8,9],
            [1,5,7,6,2,8,3,0,9,4],
            [5,8,0,3,7,9,6,1,4,2],
            [8,9,1,6,0,4,3,5,2,7],
            [9,4,5,3,1,2,6,8,7,0],
            [4,2,8,6,5,7,3,9,0,1],
            [2,7,9,3,8,0,6,4,1,5],
            [7,0,4,6,9,1,3,2,5,8]
        ];
        const inv = [0,4,3,2,1,5,6,7,8,9];
        let c = 0;
        number.split('').reverse().forEach((n, i) => {
            c = d[c][p[(i + 1) % 8][+n]];
        });
        return inv[c];
      },
      verhoeffValidate(number) {
        const d = [
            [0,1,2,3,4,5,6,7,8,9],
            [1,2,3,4,0,6,7,8,9,5],
            [2,3,4,0,1,7,8,9,5,6],
            [3,4,0,1,2,8,9,5,6,7],
            [4,0,1,2,3,9,5,6,7,8],
            [5,9,8,7,6,0,4,3,2,1],
            [6,5,9,8,7,1,0,4,3,2],
            [7,6,5,9,8,2,1,0,4,3],
            [8,7,6,5,9,3,2,1,0,4],
            [9,8,7,6,5,4,3,2,1,0]
        ];
        const p = [
            [0,1,2,3,4,5,6,7,8,9],
            [1,5,7,6,2,8,3,0,9,4],
            [5,8,0,3,7,9,6,1,4,2],
            [8,9,1,6,0,4,3,5,2,7],
            [9,4,5,3,1,2,6,8,7,0],
            [4,2,8,6,5,7,3,9,0,1],
            [2,7,9,3,8,0,6,4,1,5],
            [7,0,4,6,9,1,3,2,5,8]
        ];
        let c = 0;
        number.split('').reverse().forEach((n, i) => {
            c = d[c][p[i % 8][+n]];
        });
        return c === 0;
      }
    }
  };
  </script>
  
  <style scoped>
  .deposit-identifier {
    max-width: 500px;
    margin: 30px auto;
    padding: 20px;
    text-align: center;
    font-family: "Tahoma", sans-serif;
  }
  input {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
  }
  button {
    margin: 5px;
    padding: 10px 20px;
  }
  .btn-primary { background-color: #007bff; color: white; }
  .btn-success { background-color: #28a745; color: white; }
  .btn-secondary { background-color: #6c757d; color: white; }
  .error { color: red; }
  .success { color: green; }
  .modal-overlay {
    position: fixed; inset: 0; background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center;
  }
  .modal-content {
    background: white; padding: 20px; border-radius: 8px; width: 90%; max-width: 400px;
  }
  </style>
  